module.exports = __webpack_public_path__ + "static/media/IMG_20191010_204117066.jpg:Zone.c5ba3f43.Identifier";